const gtHousing = {
  tech: [
      'Wordpress',
      'Plesk',
      'Zendesk',
      'PHP',
      'jQuery',
      'HubSpot',
      'SASS',
      'My SQL',
      'GSAP',
      'Figma',
      'Docker',
      'Mobile Responsive',
  ],
  liveLink: 'https://housing.gatech.edu/',
  features : [
  ],
}

export default gtHousing